export const Environment = {
  /**
   * @param {"BASE_URL" | "VUE_APP_API_HOST" | "VUE_APP_API2_HOST" | "VUE_APP_API_EASYPAY" | "VUE_APP_API_MEDIA_HOST" | "VUE_APP_UI_HOST" | "VUE_APP_STRIPE_CLIENT_ID" | "VUE_APP_ASSETS_URL" | "VUE_APP_STRIPE_PUBLISHABLE_KEY" | "VUE_APP_ASSETS_HOME" | "VUE_APP_VERSION" | "VUE_APP_SIMULATED_TERMINAL"} key
   */
  get: (key) => {
    if (
      globalThis.appConfig["ENABLED"] &&
      globalThis.appConfig[key] !== undefined
    ) {
      return globalThis.appConfig[key];
    }
    return process.env[key];
  },
};
